import { SearchDocumentType, } from '../../api/api.types';
import { getDemoSearchResults } from './searchResults';
import { getTotalCount } from './getTotalCount';
export function getDemoSampleResponse(_a, demoDocumentTypes) {
    var limit = _a.limit, query = _a.query;
    return {
        results: demoDocumentTypes
            .filter(function (documentType) { return documentType !== SearchDocumentType.All; })
            .map(function (documentType) {
            var documents = getDemoSearchResults({
                documentType: documentType,
                skip: 0,
                limit: limit,
                query: query,
            });
            return {
                documentType: documentType,
                documents: documents,
                total: getTotalCount(documentType),
            };
        }),
    };
}
//# sourceMappingURL=sampleResponse.js.map